export default __webpack_public_path__ + "fonts/Lead-List-Icons.svg";